import { ChartTooltip } from "@components/Tooltip/ChartTooltip";
import { GainLossChartPercents } from "@components/Tooltip/GainLossChartPercents";
import { Theme } from "@mui/material";
import React from "react";

export const TooltipPercentage = ({
  theme,
  point,
}: {
  point: {
    name: string;
    percentage?: number;
  };
  theme?: Theme;
}) => {
  return (
    <ChartTooltip theme={theme}>
      <div
        style={{
          color: theme?.palette.text.onTooltipPrimary,
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <div
          style={{
            fontSize: theme?.typography.caption.fontSize,
            lineHeight: theme?.typography.caption.lineHeight,
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            marginRight: "4px",
          }}
        >
          {point.name}
        </div>
        {point.percentage && (
          <GainLossChartPercents
            value={point.percentage / 100}
            theme={theme}
            showIcons={false}
          />
        )}
      </div>
    </ChartTooltip>
  );
};
